import { render, staticRenderFns } from "./Professional_Publications.vue?vue&type=template&id=aff5166c&scoped=true&"
import script from "./Professional_Publications.vue?vue&type=script&lang=js&"
export * from "./Professional_Publications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff5166c",
  null
  
)

export default component.exports